<template>
  <div class="profile-screen">
    <div class="page-header">
      <div class="page-title">Profil</div>
    </div>

    <div class="profile-hero">
      <div class="profile-avatar-wrap">
        <div class="profile-avatar">🙋</div>
        <div class="profile-badge">⭐</div>
      </div>
      <div class="profile-name">{{ userName }}</div>
      <div class="profile-rank">{{ this.$store.rankLabel }}</div>
    </div>

    <div class="profile-stats">
      <div class="ps-card">
        <div class="ps-icon">🎮</div>
        <div class="ps-val">{{ this.$store.totalPlayed }}</div>
        <div class="ps-lbl">O'yinlar soni</div>
      </div>
      <div class="ps-card">
        <div class="ps-icon">🎯</div>
        <div class="ps-val">{{ this.$store.accuracy }}%</div>
        <div class="ps-lbl">Aniqlik</div>
      </div>
      <div class="ps-card">
        <div class="ps-icon">🔥</div>
        <div class="ps-val">{{ this.$store.streak }}</div>
        <div class="ps-lbl">Seriya</div>
      </div>
      <div class="ps-card">
        <div class="ps-icon">💎</div>
        <div class="ps-val">{{ this.$store.totalPts }}</div>
        <div class="ps-lbl">Jami ball</div>
      </div>
    </div>

    <div class="section-card">
      <div class="section-card-title">So'nggi o'yinlar</div>

      <div v-if="$store.state.history.length === 0" class="history-empty">
        Hali o'yin o'ynamadingiz
      </div>

      <div
        v-for="(h, i) in this.$store.history"
        :key="i"
        class="history-item"
      >
        <div class="history-icon">{{ h.emoji }}</div>
        <div class="history-info">
          <div class="history-cat">{{ h.cat }}</div>
          <div class="history-date">{{ h.date }}</div>
        </div>
        <div class="history-score" :class="scoreClass(h.pct)">
          {{ h.correct }}/{{ h.total }} ({{ h.pct }}%)
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from 'vuex';

export default {
  name: 'ProfileView',

  props: {
    userName: { type: String, default: 'Foydalanuvchi' },
  },

  data() {
    return { store }
  },

  methods: {
    scoreClass(pct) {
      if (pct >= 80) return 'good'
      if (pct >= 60) return 'ok'
      return 'bad'
    },
  },
}
</script>
